import { DependantType } from './dependant-type.interface';
import { DependantTypeService } from './dependant-type.service';

const service = new DependantTypeService();

export interface DependantTypeState {
   dependantTypes: Array<DependantType>;
}

const state: DependantTypeState = {
   dependantTypes: [],
};

const getters = {
   dependants(state: DependantTypeState) {
      return state.dependantTypes;
   },
};

const mutations = {
   SET_DEPENDANT_TYPES(state: DependantTypeState, dependantTypes: Array<DependantType>) {
      state.dependantTypes = dependantTypes;
   },
};

const actions = {
   async getDependantTypes(context: any) {
      return await service.getDependantTypes().then((response) => {
         context.commit('SET_DEPENDANT_TYPES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
